<template>
  <a class="inline-promo-banner" :href="url" :class="[$store.state.campaign, $config.platform, position, { campaign: isCampaign }]">
    <template v-if="$store.state.campaign && campaignShort">
      <img v-show="$store.state.layout !== 'mobile' && !$store.state.laptop" :src="require(`./assets/images/campaigns/${$config.platform}-${campaignShort}-banner${promotion.extend ? '-extend' : ''}-${position}.webp`)">
      <img v-show="$store.state.laptop" :src="require(`./assets/images/campaigns/${$config.platform}-${campaignShort}-banner${promotion.extend ? '-extend' : ''}-${position}-laptop.webp`)">
      <img v-show="$store.state.layout === 'mobile'" :src="require(`./assets/images/campaigns/${$config.platform}-${campaignShort}-banner${promotion.extend ? '-extend' : ''}-side-mobile.webp`)">
    </template>
    <template v-else-if="$store.state.campaign === 'one-of-two-hundred-2024'">
      <div class="line-1">
        GRAB <span class="mobile-block"><span class="highlight campaign-2">1</span> <span class="of">OF</span> <span class="highlight campaign-1">200</span></span> <span class="mobile-block"><span class="annual">ANNUAL PLANS UP TO</span><br><span class="discount">72% OFF</span></span>
      </div>
      <div class="line-2">
        <span class="button">
          Grab Now
        </span>
      </div>
    </template>
  </a>
</template>

<script>
import { CAMPAIGN_PROMOTIONS } from '@itbpbg/lms-components/src/utils/campaigns';
import { getPromotion } from '@itbpbg/lms-components/src/utils/helper';

export default {
  props: {
    position: { type: String, default: 'block', required: false },
    isCampaign: { type: Boolean },
  },
  computed: {
    campaignShort() {
      const campaigns = {
        'learn-finance': 'lf',
        'learn-data-and-ai': 'lda',
        'free-weeks-2024': 'fw2024',
        'black-friday-2024': 'bf2024',
        'cyber-monday-2024': 'cm2024',
        'cyber-monday-lifetime-2024': 'cml2024',
        'jumpstart-2025': 'js2025',
      };

      return campaigns[this.$store.state.campaign];
    },
    promotion() {
      const campaignData = CAMPAIGN_PROMOTIONS[this.$store.state.campaign];
      const promoOptions = getPromotion(campaignData.promos, {});

      return {
        buttonText: 'Start Now',
        ...promoOptions.nextPromotion,
        ...campaignData.templates,
      };
    },
    url() {
      if (this.$config.project === 'lms' && this.$store.state.campaign !== 'cyber-monday-lifetime-2024') {
        if (this.$store.state.campaign && this.$store.state.campaign.startsWith('free-')) {
          return `${this.$config.appUrl}/courses/`;
        }

        return `${this.$config.appUrl}/pricing/`;
      }

      return `${this.$config.siteUrl}/${this.$store.state.campaign}/`;
    },
  },
};
</script>

<style lang="scss" scoped>
.inline-promo-banner {
  display: block;
  color: var(--main-light);
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  margin-bottom: 32px;

  > img {
    display: block;
    max-width: 100%;
  }

  &:not(.campaign) {
    .highlight {
      font-weight: 700;

      &.campaign-2 {
        color: var(--c-oth-2);
        text-shadow:
          0 0 0 #F7AD0B,
          1px 1px 0 #F7AD0B,
          2px 2px 0 #F7AD0B,
          3px 3px 0 #F7AD0B,
          4px 4px 0 #F7AD0B,
          5px 5px 0 #F7AD0B,
          6px 6px 0 #F7AD0B;
      }

      &.campaign-1 {
        color: var(--c-oth-1);
        text-shadow:
          0 0 0 #741146,
          1px 1px 0 #741146,
          2px 2px 0 #741146,
          3px 3px 0 #741146,
          4px 4px 0 #741146,
          5px 5px 0 #741146,
          6px 6px 0 #741146;
      }
    }

    .discount {
      font-weight: 700;
      font-size: 52px;
      text-shadow: 0 0 54.94px #000, 0 0.788px 147.691px #000;
    }

    &.block {
      background-image: url('./assets/images/campaigns/ds-oth-bg-banner-block.webp');
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 38px;
      height: 184px;

      .line-1 {
        font-size: 36px;
        font-weight: 600;
        display: flex;
        align-items: center;

        .highlight {
          font-size: 120px;
          margin: 0 var(--spacing-16);
        }

        .of {
          font-size: 54px;
          font-weight: 700;
        }

        .annual {
          font-size: 28px;
          font-weight: 500;
        }

        .discount {
          font-size: 52px;
        }
      }

      .line-2 {
        flex: 0 0 auto;
      }
    }

    &.side {
      display: flex;
      align-items: center;
      flex-direction: column;
      background-image: url('./assets/images/campaigns/ds-oth-bg-banner-side.webp');
      height: auto;
      padding: 56px 30px;
      text-align: center;

      .mobile-block {
        display: block;
      }

      .line-1 {
        font-size: 32px;

        .highlight {
          font-size: 88px;
          margin: 0;
        }

        .of {
          font-size: 30px;
          font-weight: 700;
        }

        .annual {
          font-size: 24px;
        }

        .discount {
          font-size: 63px;
        }
      }

      .line-2 {
        margin-top: 24px;
      }
    }

    .button {
      width: 210px;
      height: 58px;
      position: relative;
      left: -8px;
      top: -6px;
      font-weight: 600;
      font-size: 21px;
      line-height: 100%;
      letter-spacing: 0.02em;
      cursor: pointer;
      color: var(--main-dark);
      background: var(--c-oth-2);
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition-duration: 320ms;
      box-shadow:
        0 0 0 #B7B700,
        1px 1px 0 #B7B700,
        2px 2px 0 #B7B700,
        3px 3px 0 #B7B700,
        4px 4px 0 #B7B700,
        5px 5px 0 #B7B700,
        6px 6px 0 #B7B700,
        7px 7px 0 #B7B700,
        8px 8px 0 #B7B700;
    }

    &:hover .button {
      color: var(--main-dark);
      background: #E7E700;
      box-shadow:
        0 0 0 #A7A700,
        1px 1px 0 #A7A700,
        2px 2px 0 #A7A700,
        3px 3px 0 #A7A700,
        4px 4px 0 #A7A700,
        5px 5px 0 #A7A700,
        6px 6px 0 #A7A700,
        7px 7px 0 #A7A700,
        8px 8px 0 #A7A700;
    }

    &:active .button {
      box-shadow: none;
      transition-duration: 50ms;
      transform: translate(8px, 8px);
    }

    &.fa {
      .highlight {
        &.campaign-1 {
          color: var(--accent-light-3);
          text-shadow:
            0 0 0 #024398,
            1px 1px 0 #024398,
            2px 2px 0 #024398,
            3px 3px 0 #024398,
            4px 4px 0 #024398,
            5px 5px 0 #024398,
            6px 6px 0 #024398;
        }
      }

      &.side {
        background-image: url('./assets/images/campaigns/fa-oth-bg-banner-side.webp');
      }
    }

    @include bp($bp-laptop) {
      &.block,
      &.side {
        .line-1 {
          font-size: 28px;

          .highlight {
            font-size: 92px;
          }

          .of {
            font-size: 40px;
          }

          .annual {
            font-size: 20px;
          }

          .discount {
            font-size: 40px;
          }
        }
      }

      &.side {
        .line-1 {
          .highlight {
            font-size: 76px;
          }
        }
      }
    }

    @include bp($bp-mobile) {
      .mobile-block {
        display: block;
      }

      &.block {
        background-image: url('./assets/images/campaigns/ds-oth-bg-banner-side.webp');
        flex-direction: column;
        height: auto;
        padding: 56px 30px;
        text-align: center;

        .line-1 {
          font-size: 32px;
          flex-direction: column;

          .highlight {
            font-size: 88px;
            margin: 0;
          }

          .of {
            font-size: 30px;
          }

          .annual {
            font-size: 24px;
          }

          .discount {
            font-size: 63px;
          }
        }

        .line-2 {
          margin-top: 24px;
        }
      }
    }
  }
}
</style>
